// INITIALIZE FILTERS OBJECT
import apiSearch from './apiSearch';

class FacetFilters {
  constructor(facetFields, defaultSize=10) {
    if (!FacetFilters.instance) {
      this.facetGroups = {};
      facetFields.forEach((f) => {
        let path = '', nested_field = '';
        let field = f.field.split('.');
        if (field.length > 1){
          path = field[0]
          nested_field = field[1]
        }
        this.facetGroups[f.field] = Object.assign(f, {
          selected: [],
          selected_range: [],
          buckets: [],
          more: 0,
          nested: !!(nested_field),
          path: path,
          nested_field: nested_field
        })
      });
      this.defaultSize = defaultSize;
      console.log('facets init', this)
      FacetFilters.instance = this;
    }
    return FacetFilters.instance;
  }

  toggleFilter = (field, value) => {
    // const facetGroup = this.facetGroups[field];
    if (this.facetGroups[field].type === "range") {
      if (typeof value === 'string') {  // maybe a better way to handle this? if string, clear the range
        this.facetGroups[field].selected = [];
        this.facetGroups[field].selected_range = [];
      } else {
        if (value[0] === value[1]){
          value[1] += 1;
        }
        this.facetGroups[field].selected_range = value;
        this.facetGroups[field].selected = [value.join(' to ')];
      }
    } else {
      let termIdx = this.facetGroups[field].selected.indexOf(value);
      if (termIdx < 0) {
        this.facetGroups[field].selected.push(value);
      } else {
        this.facetGroups[field].selected.splice(termIdx, 1)
      }
    }
    console.log('togglefilter',field, value, this.facetGroups[field])
  }

  clearFilters = () => {
    for (let f in this.facetGroups) {
      this.facetGroups[f].selected = [];
      if (this.facetGroups[f].type === "range"){
        this.facetGroups[f].selected_range = [];
      }
    }
  }

  // new query for facet data (aggregation query): takes query string, field, size
  facetQuery = (field, queryStr, size) => {
    let aggsObj = this.aggsQueryObj(field, size)
    return apiSearch.post(queryStr, aggsObj).then((response) => {
      this.update(response.aggs)
      return response.aggs;
    })
  }

  update = (aggs) => {
    for (let f in this.facetGroups) {
      let group = this.facetGroups[f];
      if(aggs && aggs[f] && ( aggs[f].buckets || (aggs[f]['field_value'] && aggs[f]['field_value'].buckets))) {
        // nested fields have a different response structure
        if (this.facetGroups[f]['nested']){
          group.buckets = aggs[f]['field_value'].buckets;
          group.more = aggs[f]['field_value'].sum_other_doc_count || 0
        } else {
          group.buckets = aggs[f].buckets;
          group.more = aggs[f].sum_other_doc_count || 0
        }
      } else {
        // if any are selected, they should still be shown even with no results
        if (group.selected.length > 0) {
          // TODO: what about ranges?
          group.buckets = group.selected.map((term) => {
            return {
              key: term
            }
          }); 
        } else {
          group.buckets = false;
          group.more = 0;
        }
      }
    }
  };
  
  aggsQueryObj = (fields,size) => {
    let flds = [];
    flds = Object.keys(this.facetGroups)
    let aggsObj = {
      aggs: {}
    };
    flds.forEach((val, idx) => {
      if(this.facetGroups[val].type === "range") { // maybe call the type 'date' instead?
        aggsObj.aggs[val] = {
          date_histogram: {
            field: val,
            calendar_interval: this.facetGroups[val].interval,
            format: this.facetGroups[val].date_format,
            min_doc_count: 2
          }
        }
      } else {
        if (fields){
          fields = (typeof fields === 'string') ? [fields] : fields;
        }
        else {
          fields = [];
        }
        let aggSize = (fields.includes(val)) ? size : this.defaultSize;
        // nested values have a different structure for agg
        if (this.facetGroups[val]['nested']){
          aggsObj.aggs[val] = {
            nested: {
              "path": this.facetGroups[val]['path']
            },
            aggs: {
              field_value: {
                terms: {
                  field: val + '.raw',
                  size: aggSize,
                  order: {
                    _count: "desc"
                  }
                }
              }
            }
  
          }
        } else {
          aggsObj.aggs[val] = {
            terms: {
              field: val + '.raw',
              size: aggSize,
              order: {
                _count: "desc"
              }
            }
          }
        }
      }
    });
    return aggsObj;
  };

  // update facets from query obj
  updateFromQueryObj = (obj) => {
    // -- parse filters --
    let termStr = obj.term || obj.terms;  // should really never have both
    if (termStr) {
      let selectedObj = this.parseTermStr(termStr);
      for (let key in selectedObj) {
        for (let term of selectedObj[key]) {
          this.facetGroups[key].selected.push(term)
        }
      }
    }
    let nestedTermStr = obj.nested_term;
    if (nestedTermStr) {
      let selectedNestedObj = this.parseNestedTermStr(nestedTermStr);
      for (let k in selectedNestedObj) {
        for (let t of selectedNestedObj[k]) {
          this.facetGroups[k].selected.push(t)
        }
      }
    }
    if (obj.range) {
      let selectedRanges = this.parseRangeStr(obj.range);
      for (let key in selectedRanges) {
        this.facetGroups[key].selected_range = selectedRanges[key];
        this.facetGroups[key].selected = [selectedRanges[key].join(" to ")];
      }
    }
  }

  // takes facets, returns terms uri string
  makeTermsStr = () => {
    // TODO: 'filter execution' (facets vs filters) switch between term= and terms=
    let termsStr = '';
    let nestedTermStr = '';
    for (let f in this.facetGroups) {
      let filterObj = this.facetGroups[f];
      if ((filterObj.type === "term" || filterObj.type === "hidden") && !filterObj.nested) {
        filterObj.selected.forEach((term, idx) =>{
          termsStr += encodeURIComponent(filterObj.field + '.raw') + ',' + encodeURIComponent(term) + ';'
        })
      } else if ((filterObj.type === "term" || filterObj.type === "hidden") && filterObj.nested){
        filterObj.selected.forEach((term, idx) => {
          let field = filterObj.field
          nestedTermStr += encodeURIComponent(field + '.raw') + ',' + encodeURIComponent(term) + ';'
        })
      }
    }
    return {'termStr': termsStr, 'nestedTermStr': nestedTermStr};
  };

  // takes terms url string, returns selected obj
  // make more sense to just have this in Vue app?
  parseTermStr = (str) => {
    let obj = {};
    let pairs = str.split(';');
    for (let pair of pairs) {
      if(pair) {
        let key = decodeURIComponent(pair.split('.raw,')[0]);
        let term = decodeURIComponent(pair.split('.raw,')[1]);
        obj[key] = (obj[key]) ? obj[key] : [];
        obj[key].push(term)
      }
    }
    return obj;
  };

  // takes nested terms url string, returns selected obj
  // make more sense to just have this in Vue app?
  parseNestedTermStr = (str) => {
    let obj = {};
    let pairs = str.split(';');
    for (let pair of pairs) {
      if(pair) {
        let key = decodeURIComponent(pair.split('.raw,')[0]);
        let term = decodeURIComponent(pair.split('.raw,')[1]);
        obj[key] = (obj[key]) ? obj[key] : [];
        obj[key].push(term)
      }
    }
    return obj;
  };

  // takes filterObj, returns range url string
  makeRangeStr = () => {
    let rangeStr = '';
    for (let f in this.facetGroups) {
      const filterObj = this.facetGroups[f];
      if (filterObj.type === 'range' && filterObj.selected_range.length === 2) {
        rangeStr += filterObj.field + ',' + filterObj.selected_range.join(',') + ',' + filterObj.date_format;
          // + ';'  // TODO add this semicolon to support multiple ranges?
      }
    }
    // console.log(rangeStr);
  return rangeStr;
  };

  // takes range url str, returns filterObj
  parseRangeStr = (str) => {
    let obj = {};
    let ranges = str.split(';');
    for (let r of ranges) {
      if (r) {
        let rSplit = r.split(',');
        let key = decodeURIComponent(rSplit[0]);
        let range = [decodeURIComponent(rSplit[1]), decodeURIComponent(rSplit[2])];
        obj[key] = (obj[key]) ? obj[key] : [];
        obj[key].push(range);
      }
    }
    return obj;
  };

  // takes facets object, returns array of active filter terms
  getActiveFilters = () => {
    let active = [];
    for (let f in this.facetGroups) {
      if (this.facetGroups[f].type !== 'hidden'){
        this.facetGroups[f].selected.forEach((val, idx) => {
          active.push({
            field : f,
            term : val
          })
        })
      }
    }
    return active;
  };

  isActive = (term, field) => {
    // console.log(facetFilters.facetGroups[field])
    for (let val of this.facetGroups[field].selected) {
      if(val === term) {
        return true;
      }
    }
    return false;
  }

}

export default FacetFilters;
